import axios from 'axios';

interface SendTicketParams {
  ticket: {
    category: string;
    subcategory: string;
    message: string;
    requester: {
      name: string;
      email: string;
      phone: string;
      typology: string;
      desired_typology?: string;
    };
  };
  attachment?: File;
}

export const sendTicket = async (params: SendTicketParams): Promise<void> => {
  const formData = new FormData();
  if (params.attachment)
    formData.append(
      'attachment',
      new Blob([params.attachment], { type: params.attachment.type }),
      params.attachment.name,
    );
  formData.append('ticket', JSON.stringify(params.ticket));

  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  };

  try {
    await axios.post(
      `${process.env.GATSBY_GATEWAY_API}/v1/tickets`,
      formData,
      config,
    );
  } catch (err: unknown) {
    let error = 'Something went wrong.';
    if (err instanceof Error) {
      error += ` ${err.message}`;
    }

    throw new Error(error);
  }
};
